import React from 'react';
import IconBase from './IconBase';

const VideoIcon = props => {
    return (
        <IconBase {...props} viewBox="0 0 128 128">
            <use xlinkHref="#circle" fill="#FFFFFF"></use>
            <circle className="icon-blue icons-svg" opacity="0.16" cx="64" cy="64" r="44" />
            <path className="icon-blue icons-svg" d="M64,20c-24.301,0-44,19.699-44,44s19.699,44,44,44s44-19.699,44-44S88.301,20,64,20z M55,84V44l27,20L55,84z" />
            <use xlinkHref="#circle-finish"></use>
        </IconBase>
    )
}

export default VideoIcon;